import React from 'react';
import './Login.scss';
import Panel from '../../components/ui/panel/Panel';
import Text from '../../components/ui/text/Text';
import FormGroup from '../../components/ui/form-group/FormGroup';
import { Row, Col } from 'react-grid-system';
import FormLabel from '../../components/ui/form-label/FormLabel';
import Input from '../../components/ui/input/Input';
import Checkbox from '../../components/ui/checkbox/Checkbox';
import Button from '../../components/ui/button/Button';
import counterpart from 'counterpart';
import { ILoginReducerState } from '../../reducers/loginReducer';
import { connect } from 'react-redux';
import { AppState } from '../..';
import { setLoginField, loginUser } from '../../actions/loginActions';
import history from '../../utils/history';

interface ILogin {
  loginReducer: ILoginReducerState,
  dispatch: Function
}

const Login: React.FC<ILogin> = ({ loginReducer, dispatch }) => {
  const { email, password, rememberUser, isLoginRequest, errors } = loginReducer;

  const onSubmit = async (evt: any) => {
    evt.preventDefault();
    try {
      const resp = await dispatch(loginUser(email, password))
      if(resp?.error?.data?.errorCode === "User_Login_2FA_Code_Invalid") {
        history.push("/two-factor-authentication");
      }
    }
    catch(err) {}
  }

  return (
    <form className="login" onSubmit={onSubmit}>
      <Panel>
        <FormGroup>
          <Row>
            <Col xs={12}>
              <div className="login__formgroup">
                <FormLabel target="email-input" content="LOGIN_EMAIL" />
                <Input
                  id="email-input"
                  placeholder={counterpart("LOGIN_EMAIL_PLACEHOLDER")}
                  value={email}
                  onChange={(evt: any) => dispatch(setLoginField("email", evt.target.value))}
                  isError={!!errors.email}
                  errorMsg={errors.email ? errors.email : ""}
                />
              </div>
            </Col>
          </Row>
        </FormGroup>

        <FormGroup>
          <Row>
            <Col xs={12}>
              <div className="login__formgroup">
                <FormLabel target="password-input" content="LOGIN_PASSWORD" />
                <Input
                  id="password-input"
                  placeholder="**********"
                  type="password"
                  value={password}
                  onChange={(evt: any) => dispatch(setLoginField("password", evt.target.value))}
                  isError={!!errors.password}
                  errorMsg={errors.password ? errors.password : ""}
                />
              </div>
            </Col>
          </Row>
        </FormGroup>

        <Checkbox
          id="login-remember"
          checked={rememberUser}
          content={() => (
            <div>
              <Text content="LOGIN_REMEMBER_TITLE" />
              <Text content="LOGIN_REMEMBER_SUBTITLE" noMargin />
            </div>
          )}
          isHtml={true}
          value=""
          onClick={() => dispatch(setLoginField("rememberUser", !rememberUser))}
        />
      </Panel>

      <Button
        id="login-btn"
        title="LOGIN_BTN"
        disabled={isLoginRequest}
        isLoading={isLoginRequest}
        isFullWidth
        type="submit"
      />
    </form>
  )
}

export default connect((state: AppState) => ({ loginReducer: state.login }))(Login);